import { providerConstants } from '../_constants/provider.constants';

export const initialState = {
  errors: [],
  isSaving: false,
  collection: []
}

export function provider(state = initialState, action) {
  if (action.type === providerConstants.GETALL_PROVIDERS_SUCCESS) {
    return {
      ...state,
      collection: action.collection
    }
  }

  return state;
}
